import { useMutation } from '@apollo/client/react';
import { useCallback } from 'react';
import { ARBEITSZEIT_DELETE } from './graphql/mutation';
import {
  ArbeitszeitDeleteMutation,
  ArbeitszeitDeleteMutationVariables,
} from '../../../gql/graphql';

export function useArbeitszeitDelete() {
  const [execute, result] = useMutation<
    ArbeitszeitDeleteMutation,
    ArbeitszeitDeleteMutationVariables
  >(ARBEITSZEIT_DELETE, {
    refetchQueries: ['getArbeitszeitenByDateAndStandortId', 'GetToDos'],
  });

  const arbeitszeitDelete = useCallback(
    (variables: ArbeitszeitDeleteMutationVariables) => {
      return execute({
        variables,
      });
    },
    [execute],
  );

  return [arbeitszeitDelete, result] as const;
}
